import { render, staticRenderFns } from "./generalSet.vue?vue&type=template&id=5cd46182&"
import script from "./generalSet.vue?vue&type=script&lang=js&"
export * from "./generalSet.vue?vue&type=script&lang=js&"
import style0 from "./generalSet.vue?vue&type=style&index=0&id=5cd46182&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports